webpackJsonp([36,63,64,247],{

/***/ 1282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            file: null
        };
    }
});

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    staticClass: "file"
  }, [_c('b-upload', {
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  }, [_c('a', {
    staticClass: "button is-primary"
  }, [_c('b-icon', {
    attrs: {
      "icon": "upload"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Click to upload")])], 1)]), _vm._v(" "), (_vm.file) ? _c('span', {
    staticClass: "file-name"
  }, [_vm._v("\n            " + _vm._s(_vm.file.name) + "\n        ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dropFiles: []
        };
    },

    methods: {
        deleteDropFile: function deleteDropFile(index) {
            this.dropFiles.splice(index, 1);
        }
    }
});

/***/ }),

/***/ 1285:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', [_c('b-upload', {
    attrs: {
      "multiple": "",
      "drag-drop": ""
    },
    model: {
      value: (_vm.dropFiles),
      callback: function($$v) {
        _vm.dropFiles = $$v
      },
      expression: "dropFiles"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('b-icon', {
    attrs: {
      "icon": "upload",
      "size": "is-large"
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Drop your files here or click to upload")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.dropFiles), function(file, index) {
    return _c('span', {
      key: index,
      staticClass: "tag is-primary"
    }, [_vm._v("\n                " + _vm._s(file.name) + "\n                "), _c('button', {
      staticClass: "delete is-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteDropFile(index)
        }
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_upload__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExDragDrop__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExDragDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExDragDrop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExDragDrop__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExDragDrop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExDragDrop__);
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_upload__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExDragDrop: __WEBPACK_IMPORTED_MODULE_3__examples_ExDragDrop___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExDragDropCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExDragDrop___default.a
        };
    }
});

/***/ }),

/***/ 1575:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-field class=\"file\">\n        <b-upload v-model=\"file\">\n            <a class=\"button is-primary\">\n                <b-icon icon=\"upload\"></b-icon>\n                <span>Click to upload</span>\n            </a>\n        </b-upload>\n        <span class=\"file-name\" v-if=\"file\">\n            {{ file.name }}\n        </span>\n    </b-field>\n    \n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                file: null\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1576:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field>\n            <b-upload v-model=\"dropFiles\"\n                multiple\n                drag-drop>\n                <section class=\"section\">\n                    <div class=\"content has-text-centered\">\n                        <p>\n                            <b-icon\n                                icon=\"upload\"\n                                size=\"is-large\">\n                            </b-icon>\n                        </p>\n                        <p>Drop your files here or click to upload</p>\n                    </div>\n                </section>\n            </b-upload>\n        </b-field>\n\n        <div class=\"tags\">\n            <span v-for=\"(file, index) in dropFiles\"\n                :key=\"index\"\n                class=\"tag is-primary\" >\n                {{file.name}}\n                <button class=\"delete is-small\"\n                    type=\"button\"\n                    @click=\"deleteDropFile(index)\">\n                </button>\n            </span>\n        </div>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                dropFiles: []\n            }\n        },\n        methods: {\n            deleteDropFile(index) {\n                this.dropFiles.splice(index, 1)\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1577:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExDragDrop,
      "code": _vm.ExDragDropCode,
      "title": "Drag and drop",
      "vertical": ""
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'File, Array<File>',
        values: '—',
        default: '[]'
    }, {
        name: '<code>drag-drop</code>',
        description: 'Accepts drag & drop and change its style',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>type</code>',
        description: 'Type (color) of the drag area when hovered',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-primary</code>'
    }, {
        name: '<code>disabled</code>',
        description: 'Same as native <code>disabled</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>name</code>',
        description: 'Same as native <code>name</code>',
        type: 'String',
        values: '—',
        default: '-'
    }, {
        name: '<code>required</code>',
        description: 'Same as native <code>required</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>accept</code>',
        description: 'Same as native <code>accept</code>',
        type: 'String',
        values: '—',
        default: '-'
    }, {
        name: '<code>loading</code>',
        description: 'Add the loading state',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>multiple</code>',
        description: 'Same as native, also push new item to <code>v-model</code> instead of replacing',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>native</code>',
        description: 'Replace last chosen files every time (like native file input element)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }],
    events: [{
        name: '<code>input</code>',
        description: 'Triggers when the file list is changed',
        parameters: '<code>value: File</code> or <code>File[]</code>'
    }],
    methods: [{
        name: '<code>checkHtml5Validity</code>',
        description: 'Check validation of HTML5 (add the message and type/color), also updates the <code>isValid</code> property',
        return: '<code>isValid: Boolean</code>'
    }]
}]);

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1282),
  /* template */
  __webpack_require__(1283),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1284),
  /* template */
  __webpack_require__(1285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1574),
  /* template */
  __webpack_require__(1577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/36.0ecdddd5bc47f00f365b.js